<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.gjsc1">&nbsp;&nbsp;
        <img :src="images.gjsc2">
        <br>
        <br>
        <br>
        <img :src="images.gjsc3">&nbsp;
        <img :src="images.gjsc4">
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">钢筋生产线</span>
          </u>
        </b>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span
          style="font-size:12.0pt;font-family:宋体;"
        >最近几十年在世界黑色金属冶炼界，出现了迷你冶金工厂，相对其不大的产量而言，是一种二次加工的企业。迷你冶金工厂在黑色冶金界是一种更具发展活力、更有效率的方向。和一体化大钢厂相比，这种迷你工厂的优势在于低廉的费用，更少影响生态和周围环境。</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p style="margin-left:18.0pt;text-indent:-18.0pt;">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span>
            1.
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">迷你工厂基本竞争优势</span>
        <span style="font-size:12.0pt;font-family:Arial;">—</span>
        <span style="font-size:12.0pt;font-family:宋体;">灵活、简单、紧凑的工艺，适合市场需求，生产链简短。</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="margin-left:18.0pt;text-indent:-18.0pt;">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span>
            2.
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">投资低，建设周期短。</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="margin-left:18.0pt;text-indent:-18.0pt;">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span>
            3.
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">产品种类专业化，可以针对不同的消费者。</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="margin-left:18.0pt;text-indent:-18.0pt;">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span>
            4.
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">在优化生产费用条件下，劳动生产率很高。</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p style="margin-left:18.0pt;text-indent:-18.0pt;">
        <span style="font-size:12.0pt;font-family:Arial;">
          <span>
            5.
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">新工艺，新设备在不断的进步中。</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">迷你冶金工厂设计紧凑，由三个基本工艺部分组成</span>
        <span style="font-size:12.0pt;font-family:Arial;">—</span>
        <span style="font-size:12.0pt;font-family:宋体;">电炉炼钢、浇铸和轧制。</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">我公司可以提供从设计，设备提供到试生产的交钥匙服务。</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">
          <br>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
        <img :src="images.gjsc5" style="line-height:1.5;">
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        gjsc1: require("../../../assets/img/common/gjsc1.jpg"),
        gjsc2: require("../../../assets/img/common/gjsc2.jpg"),
        gjsc3: require("../../../assets/img/common/gjsc3.jpg"),
        gjsc4: require("../../../assets/img/common/gjsc4.jpg"),
        gjsc5: require("../../../assets/img/common/gjsc5.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/gjsc.vue